module.exports = __webpack_public_path__ + "images/help/header-background@2x-a98b253efb1cf53cd89596906f0f5dde.png";